import { MapPin } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const LOCALES = [
  { id: "centro", name: "Local Centro", status: "Correcto", ok: true, bars: [72, 88, 64, 92] },
  { id: "norte", name: "Local Norte", status: "Atención", ok: false, bars: [55, 40, 62, 38] },
  { id: "sur", name: "Local Sur", status: "Correcto", ok: true, bars: [80, 70, 90, 84] },
];

export const MultiLocal = () => (
  <section data-testid="multilocal-section" className="py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-6 md:px-12 lg:grid-cols-2 lg:gap-20">
      <Reveal>
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.22em] text-[#0F4D3F]/60">Multilocal</p>
        <h2 className="text-4xl font-medium tracking-tight text-[#1F3D35] md:text-5xl" data-testid="multilocal-title">
          Diseñado para operaciones con uno o muchos locales
        </h2>
        <p className="mt-5 max-w-md text-base font-light leading-relaxed text-[#1F3D35]/70 md:text-lg" data-testid="multilocal-text">
          Controla cada local por separado y visualiza toda tu operación desde una misma plataforma.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="rounded-3xl border border-[#1F3D35]/8 bg-white p-6 shadow-[0_24px_64px_rgba(15,77,63,0.10)] md:p-8" data-testid="multilocal-panel">
          <div className="mb-6 flex items-center justify-between">
            <span className="text-sm font-semibold text-[#1F3D35]">Estado de locales</span>
            <div className="flex gap-1.5">
              <span className="h-2 w-2 rounded-full bg-[#1F3D35]/15" />
              <span className="h-2 w-2 rounded-full bg-[#1F3D35]/15" />
              <span className="h-2 w-2 rounded-full bg-[#C6F04A]" />
            </div>
          </div>
          <div className="space-y-3">
            {LOCALES.map(({ id, name, status, ok, bars }, i) => (
              <motion.div
                key={id}
                data-testid={`local-${id}`}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 + i * 0.12, duration: 0.5 }}
                className="flex items-center gap-4 rounded-2xl border border-[#1F3D35]/6 bg-[#F8F8F3] p-4"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white text-[#0F4D3F] shadow-sm">
                  <MapPin size={17} />
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-semibold text-[#1F3D35]">{name}</p>
                  <div className="mt-1.5 flex items-end gap-1">
                    {bars.map((h, j) => (
                      <span
                        key={j}
                        className={`w-4 rounded-sm ${ok ? "bg-[#0F4D3F]/20" : "bg-[#F59E0B]/35"}`}
                        style={{ height: `${h / 6}px` }}
                      />
                    ))}
                  </div>
                </div>
                <span
                  data-testid={`local-status-${id}`}
                  className={`flex shrink-0 items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold ${
                    ok ? "bg-[#DCECCF] text-[#0F4D3F]" : "bg-[#FEF3C7] text-[#92400E]"
                  }`}
                >
                  <span className={`h-1.5 w-1.5 rounded-full ${ok ? "bg-[#22C55E]" : "bg-[#F59E0B]"}`} />
                  {status}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
